/**
 * 导出文件模板
 */
export function fileStreamTransverter(data, fileName, fileType = ".xlsx") {
  const a = document.createElement("a");
  const href = window.URL.createObjectURL(data);
  a.download = fileName + fileType;
  a.href = href;
  a.click();

  window.URL.revokeObjectURL(href);
}

/*设置时间格式*/
export function formatDate(date, fmt) {
  if (IsNullOrEmpty(date)) {
    return "";
  }
  fmt = fmt ? fmt : "yyyy-MM-dd hh:mm:ss";
  if (date) {
    if (date.length > 4 && date.length < 8) {
      date += "/01"; //兼容iE\火狐
    }
    //   if (typeof date === 'string') date = date.replace('-', '/').replace('-', '/') //兼容iE\火狐
    date = new Date(date);
    const o = {
      "M+": date.getMonth() + 1, //月份
      "d+": date.getDate(), //日
      "h+": date.getHours(), //小时
      "m+": date.getMinutes(), //分
      "s+": date.getSeconds(), //秒
      "q+": Math.floor((date.getMonth() + 3) / 3), //季度
      S: date.getMilliseconds(), //毫秒
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    for (const k in o)
      if (new RegExp("(" + k + ")").test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1
            ? o[k]
            : ("00" + o[k]).substr(("" + o[k]).length)
        );
  }
  return fmt;
}

export function IsNullOrEmpty(obj, includeZero = false) {
  if (includeZero) {
    return (
      obj === "undefined" ||
      obj === undefined ||
      obj === null ||
      obj === "" ||
      obj.length === 0 ||
      obj == 0
    );
  } else {
    return (
      obj === "undefined" ||
      obj === undefined ||
      obj === null ||
      obj === "" ||
      obj.length === 0
    );
  }
}

export function imgBase64(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = url;
    image.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = image.naturalWidth; // 使用 naturalWidth 为了保证图片的清晰度
      canvas.height = image.naturalHeight;
      canvas.style.width = `${canvas.width / window.devicePixelRatio}px`;
      canvas.style.height = `${canvas.height / window.devicePixelRatio}px`;
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        return null;
      }
      ctx.drawImage(image, 0, 0);
      const base64 = canvas.toDataURL("image/png");
      return resolve(base64);
    };
    image.onerror = (err) => {
      return reject(err);
    };
  });
}

/**
 * @parmas defaultNum --默认为0，获取当前月份，-1为上一个月，+1为后一个月；以此类推。
 */
export function getDefaultMonth(defaultNum = 0) {
  // 获取当前日期
  const currentDate = new Date();
  // 将日期减去指定的月份
  currentDate.setMonth(currentDate.getMonth() + defaultNum);
  // 格式化日期为"YYYY-MM"格式
  const year = currentDate.getFullYear();
  const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
  const formattedDate = `${year}-${month}`;
  // console.log(formattedDate);
  return formattedDate;
}

/**
 *
 * @param {*} password 密码明文
 * @returns 效验密码复杂度，密码必须至少包含一个大写字母、一个小写字母、一个数字和一个特殊符号
 */
export function isStrongPassword(password) {
  const uppercaseRegex = /[A-Z]/;
  const lowercaseRegex = /[a-z]/;
  const digitRegex = /[0-9]/;
  const specialCharRegex = /[!@#$%^&*()_+{}\\[\]:;<>,.?~\\/-]/;

  return (
    uppercaseRegex.test(password) &&
    lowercaseRegex.test(password) &&
    digitRegex.test(password) &&
    specialCharRegex.test(password)
  );
}
